(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Reveal on scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-ol-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Product tabs */
  function initTabs(root) {
    (root || document).querySelectorAll('[data-ol-tabs]').forEach(function (wrap) {
      wrap.querySelectorAll('[data-ol-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-ol-tab');
          wrap.querySelectorAll('[data-ol-tab]').forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          wrap.querySelectorAll('[data-ol-panel]').forEach(function (p) {
            var on = p.getAttribute('data-ol-panel') === id;
            p.hidden = !on;
            p.classList.toggle('is-active', on);
          });
        });
      });
    });
  }

  /* Kelvin slider */
  var stops = [
    { k: 2200, c: [255, 147, 41] },
    { k: 2700, c: [255, 180, 107] },
    { k: 3000, c: [255, 201, 138] },
    { k: 3500, c: [255, 222, 180] },
    { k: 4000, c: [255, 241, 220] }
  ];
  var advice = [
    { max: 2400, name: 'Dim-to-warm', text: 'Kaarslicht-sfeer. Dimt naar een gouden gloed, ideaal voor terras en lounge-hoek.' },
    { max: 2850, name: 'Extra warm wit', text: 'Warm en sfeervol, zoals een gloeilamp. De favoriet voor terras, veranda en voordeur.' },
    { max: 3400, name: 'Warm wit', text: 'Warm maar net wat frisser. Mooi op moderne gevels en bij strakke architectuur.' },
    { max: 4100, name: 'Neutraal wit', text: 'Helder en functioneel. Prettig bij oprit, carport, schuur en looppaden waar je goed wilt zien.' }
  ];
  function kColor(k) {
    for (var i = 0; i < stops.length - 1; i++) {
      var a = stops[i], b = stops[i + 1];
      if (k >= a.k && k <= b.k) {
        var t = (k - a.k) / (b.k - a.k);
        var c = a.c.map(function (v, j) { return Math.round(v + (b.c[j] - v) * t); });
        return 'rgb(' + c.join(',') + ')';
      }
    }
    return k < stops[0].k ? 'rgb(255,147,41)' : 'rgb(255,241,220)';
  }
  function initKelvin(root) {
    (root || document).querySelectorAll('[data-ol-kelvin]').forEach(function (wrap) {
      var range = wrap.querySelector('[data-ol-k-range]');
      var scene = wrap.querySelector('[data-ol-k-scene]');
      if (!range || !scene) return;
      function set(k) {
        k = parseInt(k, 10);
        range.value = k;
        scene.style.setProperty('--ol-light', kColor(k));
        var a = advice.filter(function (x) { return k <= x.max; })[0] || advice[advice.length - 1];
        wrap.querySelector('[data-ol-k-value]').textContent = k;
        wrap.querySelector('[data-ol-k-name]').textContent = a.name;
        wrap.querySelector('[data-ol-k-text]').textContent = a.text;
        var lbl = wrap.querySelector('[data-ol-k-label]');
        if (lbl) lbl.textContent = k <= 2400 ? 'Dim-to-warm' : k + 'K';
        wrap.querySelectorAll('[data-ol-k-set]').forEach(function (b) {
          b.classList.toggle('is-active', Math.abs(parseInt(b.getAttribute('data-ol-k-set'), 10) - k) < 150);
        });
      }
      range.addEventListener('input', function () { set(range.value); });
      wrap.querySelectorAll('[data-ol-k-set]').forEach(function (b) {
        b.addEventListener('click', function () { set(b.getAttribute('data-ol-k-set')); });
      });
      set(range.value);
    });
  }

  /* IP guide */
  function initIP(root) {
    (root || document).querySelectorAll('[data-ol-ip]').forEach(function (wrap) {
      var scene = wrap.querySelector('[data-ol-ip-scene]');
      wrap.querySelectorAll('[data-ol-ip-btn]').forEach(function (btn) {
        btn.addEventListener('click', function (ev) {
          if (ev.target.closest('a')) return;
          var z = btn.getAttribute('data-ol-ip-btn');
          if (scene) scene.setAttribute('data-active', z);
          wrap.querySelectorAll('.ol-ip__item').forEach(function (it) {
            it.classList.toggle('is-active', it.getAttribute('data-ol-ip-btn') === z);
          });
        });
      });
    });
  }

  /* Read more clamp */
  function initClamp(root) {
    (root || document).querySelectorAll('[data-ol-clamp]').forEach(function (el) {
      var btn = el.parentElement.querySelector('[data-ol-clamp-btn]');
      if (!btn) return;
      if (el.scrollHeight <= el.clientHeight + 8) { el.classList.add('is-short'); btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var open = el.classList.toggle('is-open');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  }

  /* Sticky add to cart */
  function initStickyATC() {
    var bar = document.querySelector('[data-ol-satc]');
    if (!bar) return;
    var submit = document.querySelector('product-info .product-form__submit, product-info form[action*="/cart/add"] button[type="submit"]');
    if (!submit) return;
    bar.hidden = false;
    var priceEl = bar.querySelector('[data-ol-satc-price]');
    var variantEl = bar.querySelector('[data-ol-satc-variant]');
    var btn = bar.querySelector('[data-ol-satc-btn]');
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
    });
    io.observe(submit);
    function sync() {
      var p = document.querySelector('product-info .price__container .price-item--sale, product-info .price__container .price-item--regular');
      var sale = document.querySelector('product-info .price--on-sale .price-item--sale');
      var src = sale || p;
      if (src && priceEl) priceEl.textContent = src.textContent.trim();
      var checked = Array.prototype.map.call(document.querySelectorAll('product-info variant-selects input:checked, product-info variant-selects select'), function (i) { return i.value; });
      if (variantEl && checked.length) variantEl.textContent = checked.join(' / ');
      btn.disabled = submit.disabled;
      btn.textContent = submit.disabled ? (submit.textContent || '').trim() : btn.getAttribute('data-label');
    }
    btn.setAttribute('data-label', btn.textContent.trim());
    var info = document.querySelector('product-info');
    if (info) new MutationObserver(function () { window.requestAnimationFrame(sync); }).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    document.addEventListener('change', function () { setTimeout(sync, 250); });
    btn.addEventListener('click', function () {
      if (submit.disabled) { submit.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      submit.click();
    });
    sync();
  }

  function initAll(root) {
    initReveal(root); initTabs(root); initKelvin(root); initIP(root); initClamp(root);
  }

  ready(function () { initAll(document); initStickyATC(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
